import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { TextField, InputAdornment, IconButton } from "@material-ui/core/";

// Comps
import renderDropZoneField from '../../../components/form/DropZone';
import LoadingButton from '../../../components/LoadingButton';

// Icons
import EyeIcon from 'mdi-react/EyeIcon';
import EyeOffIcon from 'mdi-react/EyeOffIcon';
import HelpCircleIcon from 'mdi-react/HelpCircleIcon';
import LockIcon from 'mdi-react/LockIcon';
import WarningIcon from 'mdi-react/AlertCircleOutlineIcon';

const renderTextField = ({ input = {}, label, meta: { touched, error }, children, type, InputProps}) => (
  <div className='material-form__field-wrapper'>
    <TextField
      className='material-form__field'
      label={label}
      error={touched && !!error}
      value={input.value}
      children={children}
      type={type}
      variant='outlined'
      onChange={(e) => {
        e.preventDefault();
        input.onChange(e.target.value);
      }}
      InputProps={ InputProps }
      />
    { touched && error && <span className='form__form-group-error'>{ error }</span> }
  </div>
); // END renderTextField

class FormSatFirstPage extends PureComponent {
  static propTypes = {
    modal: PropTypes.object

  } // END propTypes

  state = {
    showPassword: false

  } // END state

  showPassword = (e) => {
    e.preventDefault();
    this.setState({ showPassword: !this.state.showPassword});

  } // END showPassword

  selfToggle = () => {
    this.props.modal.toggle()
  }

  render() {
    const { handleSubmit, isLoading } = this.props;
    const { showPassword } = this.state;

    return (
      <form className='material-form' onSubmit={ handleSubmit }>
        <Row>
          <Col>
            <h2 className="page-title sat">1 de 2: Accesos del SAT</h2>
            <h5>Ingresa tus datos fiscales para iniciar la conexión a tu cuenta del SAT.</h5>
          </Col>
        </Row>
        <Row style={{marginTop:35, marginBottom:5}}>
          <Col>
            <h4 className="inline-title">Certificado de sello digital (CSD)</h4>
            <span className="help-text">
              <HelpCircleIcon/>
              <a target="_blank" rel="noopener noreferrer" href="https://www.sat.gob.mx/tramites/17507/envia-la-solicitud-para-tu-certificado-de-sello-digital-para-emitir-facturas-electronicas">
                ¿Cómo obtener tu certificado?
              </a>
            </span>
            <hr/>
          </Col>
        </Row>
        <Row>
          <Col sm={6} md={6} lg={6} xl={6}>
            <div className='form__form-group'>
              <label className='form__form-group-label'>Archivo .CER</label>
              <div className='form__form-group-field'>
                <Field
                  name='sat_certificate'
                  component={ renderDropZoneField }
                  customHeight
                />
              </div>
            </div>
          </Col>
          <Col sm={6} md={6} lg={6} xl={6}>
            <div className='form__form-group'>
              <label className='form__form-group-label'>Archivo .KEY</label>
              <div className='form__form-group-field'>
                <Field
                  name='sat_private_key'
                  component={ renderDropZoneField }
                  customHeight
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Field
              name='sat_private_key_password'
              component={ renderTextField }
              type={showPassword ? 'text' : 'password'}
              label='Contraseña'
              InputProps={{
                  endAdornment: (
                      <InputAdornment
                        position="end"
                        disablePointerEvents={false} >
                        <IconButton style={{padding: 0}} onClick={(e) => {this.showPassword(e)}}>
                          {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                        </IconButton>
                    </InputAdornment>
                  )
              }}
            />
          </Col>
        </Row>
        {this.props.satError !== null &&
          <Row style={{marginBottom:30}}>
            <Col className="sat__form-group-error">
              <p><WarningIcon/> {this.props.parseError(this.props.satError.code)}</p>
            </Col>
          </Row>
        }
        <Row style={{marginBottom:5}}>
          <Col>
            <p style={{textAlign:"center", margin:"auto", marginBottom:15}}><span className="help-text"><LockIcon/><a target="_blank" rel="noopener noreferrer" href="https://help.porcobrar.com/">Tus datos están protegidos de forma segura con encriptación de 256 bits,<br/> consulta nuestros términos y condiciones aquí.</a></span></p>
          </Col>
        </Row>
        <Row>
          <Col className="align-end">
            <Button
              onClick={()=>this.selfToggle()}
              color="secondary"
              className='secondary-btn'>
              Cancelar
            </Button>
            <Button
              className='btn-green btn-sat-first-page-width'
              color="success">
                <LoadingButton isLoading={isLoading}  placeholder='Siguiente'/>
            </Button>
          </Col>
        </Row>
      </form>
    );
  }
}; //END FormSatFirstPage

const validate = values => {
  const {
      // Required
      sat_certificate,
      sat_private_key,
      sat_private_key_password

    } = values, errors = {};

  if (!sat_certificate) errors.sat_certificate = 'Debes agregar un certificado';
  if (!sat_private_key) errors.sat_private_key = 'Debes agregar tu llave privada';
  if (!sat_private_key_password) errors.sat_private_key_password = 'Proporciona una contraseña';

  return errors;

}; // END validate

export default reduxForm({ form: 'SAT_CERTS', validate })(FormSatFirstPage);



// WEBPACK FOOTER //
// ./src/containers/account/components/FormSatAccess.js